module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[24]145.67e592b.woff2";